import { FieldErrors, FieldValues } from 'react-hook-form/dist/types';

type HasInputError = (props: {
    errorKey: string;
    formErrors: FieldErrors<FieldValues>;
}) => boolean;

export const hasInputError: HasInputError = ({ errorKey, formErrors }) =>
    formErrors[errorKey] !== undefined;
